import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { fmtPLN } from "@/lib/api";
import { Link } from "react-router-dom";

export function KPIStatCard({
  label,
  value,
  sublabel,
  icon: Icon,
  currency = false,
  testId,
  accent = "primary",
  to,
}) {
  const display = currency ? fmtPLN(value) : value === null || value === undefined ? "—" : value;

  const inner = (
    <Card
      className={`tt-card overflow-hidden ${to ? "hover:shadow-md hover:border-[var(--tt-primary)]/30 transition-all cursor-pointer" : ""}`}
      data-testid={testId || "kpi-card"}
    >
      <CardContent className="p-4 md:p-5">
        <div className="flex items-start justify-between">
          <div>
            <div className="text-xs md:text-sm font-medium text-[var(--tt-muted)] uppercase tracking-wide">{label}</div>
            <div
              className="mt-2 text-2xl md:text-3xl font-semibold tracking-tight tabular-nums tt-display"
              data-testid={`${testId || "kpi"}-value`}
            >
              {display}
            </div>
            {sublabel ? <div className="mt-1 text-xs text-[var(--tt-muted)]">{sublabel}</div> : null}
          </div>
          {Icon ? (
            <div
              className={`flex h-10 w-10 items-center justify-center rounded-xl ${
                accent === "primary"
                  ? "bg-[var(--tt-primary)]/10 text-[var(--tt-primary)]"
                  : accent === "accent"
                    ? "bg-[var(--tt-accent)]/15 text-[var(--tt-accent-fg)]"
                    : accent === "critical"
                      ? "bg-[var(--tt-critical-bg)] text-[var(--tt-critical-fg)]"
                      : "bg-slate-100 text-slate-700"
              }`}
            >
              <Icon className="h-5 w-5" />
            </div>
          ) : null}
        </div>
      </CardContent>
    </Card>
  );

  if (to) {
    return (
      <Link to={to} className="block focus:outline-none focus:ring-2 focus:ring-[var(--tt-primary)] rounded-xl">
        {inner}
      </Link>
    );
  }
  return inner;
}
